import React, { memo, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import usePay from "../hooks/usePay";
import { QRCodeCanvas } from "qrcode.react";
import Modal from "./Modal";
import "./styles/scss/GamePay.scss";
import { CTX_STATE, openBrowser, specialNavigate } from "../common";
import Big from "big.js";

const productList = [
	{
		id: 2,
		productPrice: 19,
		originPrice: 30,
	},
	{
		id: 1,
		productPrice: 35,
		originPrice: 46,
	},
];

function App(props) {
	const { details = {}, isShow, onClose } = props;
	const {
		payId,
		payName,
		payDesc,
		payPrice,
		payImg,
		from,
		img_url,
		list_img,
		gameType,
		buyCount,
		pro_type,
	} = details;

	const navigate = useNavigate();
	const _state = useContext(CTX_STATE);
	const isWjyz = from === "wjyz" ? true : false;
	const {
		product,
		setProduct,
		payType,
		setPayType,
		agree,
		setAgree,
		qrcode,
		time,
		setRefresh,
		paySucc,
	} = usePay({
		productList,
		payType: 0,
		isShow,
		onClose,
		from: "GamePay",
		img_url,
		isWjyz,
		list_img,
		payId,
		payPrice,
		buyCount,
	});
	
	const payTypeArr =
		pro_type === "绝地求生(金币)"
			? [
					{
						type: 1,
						name: "ali",
					},
			  ]
			: [
					{
						type: 0,
						name: "wx",
					},
					{
						type: 1,
						name: "ali",
					},
			  ];

	useEffect(() => {
		setPayType(pro_type === "绝地求生(金币)" ? 1 : 0);
	}, [pro_type, setPayType]);

	useEffect(() => {
		if (!paySucc) return;

		if (isWjyz) {
			if (product === null) {
				Modal.tips({
					icon: "succ",
					contentHead: `你已成功购买【${payName}】`,
					contentBody: "请至订单详情页提取卡密",
					onOk: (c) => {
						c();
						specialNavigate("/Personal/2", _state.token, navigate, isWjyz, {});
					},
					okText: "查看详情",
					onCancel: (c) => {
						c();
					},
					cancelText: "继续购买",
				});
			} else {
				//游戏和加速器
				Modal.tips({
					icon: "succ",
					contentHead: "购买成功",
					contentBody: "请至订单详情页提取卡密",
					onOk: (c) => {
						c();
						specialNavigate("/Personal/2", _state.token, navigate, isWjyz, {});
					},
					okText: "查看详情",
					onCancel: (c) => {
						c();
					},
					cancelText: "继续购买",
				});
			}
		} else {
			if (product === null) {
				Modal.tips({
					icon: "succ",
					contentHead: `你已成功购买【${payName}】共享版`,
					contentBody: "请加速后登录游戏，可避免无法登录或游戏卡顿",
					onOk: (c) => {
						c();
					},
					okText: "好的",
					onCancel: (c) => {
						c();
					},
					cancelText: "继续购买",
				});
			} else {
				//游戏和加速器
				Modal.tips({
					icon: "succ",
					contentHead: "你已成功购买游戏及加速器会员服务",
					contentBody: "请前往加速器官网下载使用加速服务",
					onOk: (c) => {
						c();
						specialNavigate("/Personal/1", _state.token, navigate, isWjyz, {});
					},
					okText: "查看详情",
					onCancel: (c) => {
						c();
					},
					cancelText: "确定",
				});
			}
		}
	}, [paySucc, isWjyz, product, _state.token, navigate, payName]);

	return (
		<Modal className="popup-game-pay" visible={isShow} onClose={onClose}>
			<div className="title">确认订单</div>
			<div className="game-info">
				<div className="left">
					<div
						style={{
							backgroundImage: `url(${payImg})`,
						}}
					></div>
					<div>
						<div>{payName}</div>
						<div>{payDesc}</div>
						<div className="share">{gameType}</div>
					</div>
				</div>
				<div className="right">
					￥{new Big(payPrice).times(buyCount).toNumber()}
				</div>
			</div>

			<div className="jsq-title">
				<div className="left">
					<div></div>超值组合
				</div>
				<div className="right">有效解决游戏自身登录、联机匹配问题</div>
			</div>

			<div className="product-list">
				{productList.map((ele, index) => {
					return (
						<button
							key={index}
							type="button"
							className={`product product-${index}${
								product === index ? " active" : ""
							}`}
							onClick={() => {
								if (product === index) {
									setProduct(null);
								} else {
									setProduct(index);
								}
							}}
						>
							<div>({ele.originPrice}元)</div>
							<div>+{ele.productPrice}元</div>
						</button>
					);
				})}
			</div>

			<div className="pay-title">
				<div className="left">
					<div></div>支付方式
				</div>
			</div>

			<div className="pay-list">
				<div className="pay-type">
					{payTypeArr.map((ele) => {
						const { type, name } = ele;

						return (
							<button
								type="button"
								key={type}
								className={`${name} ${payType === type ? "active" : ""}`}
								onClick={() => {
									setPayType(type);
								}}
							></button>
						);
					})}
				</div>
				<div className="qrcode">
					<QRCodeCanvas value={qrcode} size={78} />
					<div
						className="shadow"
						style={{ display: agree && time !== 0 ? "none" : "block" }}
					>
						{agree ? (
							<>
								二维码已过期
								<button
									type="button"
									onClick={() => {
										setRefresh((c) => !c);
									}}
								>
									刷新
								</button>
							</>
						) : (
							"请先勾选协议"
						)}
					</div>
				</div>
				<div className="pay-info">
					<div>小计：</div>
					<div>
						<span>
							￥
							<span>
								{new Big(payPrice)
									.times(buyCount)
									.plus(
										product === null ? 0 : productList[product]["productPrice"]
									)
									.toNumber()}
							</span>
						</span>
					</div>
					<div>
						<button
							type="button"
							className={agree ? "active" : ""}
							onClick={() => {
								setAgree(!agree);
							}}
						></button>
						<div
							onClick={() => {
								openBrowser(
									isWjyz
										? "http://www.wanjiayizhan.com/UserAgreement"
										: "http://www.wanjiayizhan.com/GXUserAgreement"
								);
							}}
						>
							{isWjyz ? "用户协议" : "同意游戏共享协议"}
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
}

export default memo(App);
